export default __webpack_public_path__ + "static/media/cuisse.dfdaf7ec.jpg";